import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage, useIntl } from 'react-intl'
import { getSensorsUrl } from '../../../../../../utils/sensor'
import { useHistory } from 'react-router-dom'
import { useState } from 'react'
import Item from '../../../../fragments/item/element'
import withSource from '../../../../../../hocs/source-scoll'
import Affix from '../../../../../../components/affix'
import Checkbox from '../../../../components/checkbox'

const Head = withSource(props => {
    useStyles(classes)
    const history = useHistory()
    const {
        title,
        message,
        products,
        innerRef,
        intl,
        label
    } = props

    const sensors = {
        resourcepage_title: 'cart',
        resource_type: '26',
        resource_content: 'add on',
        resource_position: 1,
    }

    const goHandle = () => {
        history.push(getSensorsUrl('/cart/collect-products?type=2', { ...sensors }))
    }

    return <div className={classes.Head}>
        <div className={classes.Title}>
            <span>
                <span dangerouslySetInnerHTML={{ __html: title }} />
                {
                    label &&
                    <span className={classes.ExtraDiscount} dangerouslySetInnerHTML={{__html:label}}></span>
                }
            </span>
            {
                (products?.length > 0) ? <span
                    ref={innerRef}
                    data-position={sensors.resource_position}
                    data-type={sensors.resource_type}
                    data-content={sensors.resource_content}
                    data-title={sensors.resourcepage_title}
                    className={classes.Pick} onClick={() => goHandle()}>
                    {
                        products?.length > 0 ? <FormattedMessage id="repick" defaultMessage="Repick" /> : <FormattedMessage id="pick" defaultMessage="Pick" />
                    }
                    {'>'}
                </span> : <span
                    ref={innerRef}
                    data-position={sensors.resource_position}
                    data-type={sensors.resource_type}
                    data-content={sensors.resource_content}
                    data-title={sensors.resourcepage_title}
                    className={classes.Add} onClick={() => goHandle()}>
                    <FormattedMessage id="pick" defaultMessage="Pick" />{'>'}
                </span>
            }

        </div>
        <div className={classes.Description}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
        </div>
    </div>
})

export default props => {
    const { addOnItemsRegionalCase, itemDeleteHandle} = props
    const { title, description, products, label } = addOnItemsRegionalCase
    const [showFixed, setShowFixed] = useState(false)
    const intl = useIntl()

    return (
        <div>
            {
                products?.length <= 0 ?
                <Affix offsetTop={44} offsetStart={10} zIndex={2} style={{left: 0}} callBack={(f) => {
                    // console.log(f)
                    setShowFixed(f)
                }}>
                    {/* 未选择礼物需要置顶 */}
                    <div className={`${classes.Container} ${showFixed ? classes.FixedContainer: ''}`}>
                        <Head title={title} message={description} products={products} intl={intl} label={label}/>
                    </div>
                </Affix>:
                <div className={`${classes.Container}`}>
                    <Head title={title} message={description} products={products} intl={intl} label={label}/>
                    {
                        products?.length > 0 ?
                            <React.Fragment>
                                {
                                    products?.map((p,i) => {
                                        return <div className={`${classes.Bd} ${classes.GiftBd}`} key={p?.id}>
                                            <div className={`${classes.ItemBox} ${i > 0 && classes.ItemMargin}`}>
                                                <Item
                                                    item={p}
                                                    isAddOn
                                                    isCart
                                                    itemDeleteHandle={itemDeleteHandle}
                                                    addOnMsg={label}/>
                                            </div>
                                        </div>
                                    })
                                }
                            </React.Fragment>:
                            <React.Fragment></React.Fragment>
                    }
                </div>
            }
        </div>
    )
}

export const EditAddsOn = props => {
    useStyles(classes)
    const { editing, selectedItems, itemSelectHandle, addOnItemsRegionalCase } = props

    const { product } = addOnItemsRegionalCase || {}
    const { canRemove } = product || {}

    const clickHandle = e => {
        itemSelectHandle(product)
    }

    let selected

    if (editing) {
        selected = selectedItems?.some(i => i.id === product?.id)
    } else {
        selected = product?.selected
    }

    return canRemove && <div className={classes.EditAddsOnBox}>
        <div className={classes.SelectableItem}>
            <div className={`${classes.SelectArea}`}>
                <Checkbox onClick={clickHandle} selected={selected} />
            </div>
            <div className={classes.ItemArea}>
                <Item item={product} isAddOn isCart {...props} />
            </div>
        </div>
    </div>
}